import { useCallback, useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";
import { generatePath, useNavigate } from "react-router-dom";
import { AdminIcon, Box, NavLink } from "../../../common/components";
import SearchTeamsModal from "../../../components/SearchTeamsModal/SearchTeamsModal";
import { AppToolbarContext } from "../../../context/AppToolbar";
import { spacing } from "../../../styles/theme";
import { ROUTES } from "../../../constant/common.constant";
import { useTeam } from "../../../context/Team";

export const SearchTeams = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { refetchTeams } = useTeam();
  const { toggleNavigationDrawerOpen } = useContext(AppToolbarContext);

  const { addToTeam, teams } = useTeam();

  const [showSearchModal, setShowSearchModal] = useState(false);

  const onSearchCloseClick = () => {
    toggleNavigationDrawerOpen?.();
    setShowSearchModal(false);
  };

  const onClick = useCallback(() => {
    setShowSearchModal(true);
  }, [setShowSearchModal]);

  const onAddToTeam = useCallback(
    async (teamId: string) => {
      const result = await addToTeam(teamId);
      await refetchTeams({ skipLoading: true });
      navigate(generatePath(ROUTES.TEAM, { teamId }));
      return result;
    },
    [addToTeam, refetchTeams, navigate]
  );

  return (
    <Box display={"flex"} alignItems={"center"} gap={"4px"}>
      <NavLink
        onClick={onClick}
        to=""
        content={
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={"4px"}
            width={"100%"}
          >
            <Typography variant="actionSmallIcon">
              {t("navigation.search_team")}
            </Typography>
            <AdminIcon />
          </Box>
        }
        startIcon="search"
        style={{ marginRight: spacing.mediumDesktop, width: "100%" }}
      />
      <SearchTeamsModal
        open={showSearchModal}
        myTeams={teams || []}
        onClickClose={onSearchCloseClick}
        onAddToTeam={onAddToTeam}
      />
    </Box>
  );
};
